import { Loader2 } from 'lucide-react';

import { cn } from '@shared/utils';

export const Spinner = ({ className }: { className?: string }) => {
  return <Loader2 className={cn('h-10 w-10 animate-spin', className)} />;
};
